import type { KadeweUser } from "~/types";

export default defineNuxtRouteMiddleware(() => {
    const user = useSanctumUser<KadeweUser>();

    if (!user.value?.special_events.advent_calendar) {
        throw createError({ status: 404 });
    }
});
